import { css } from "lit";

export const autocompleteMultiSelectStyles = css`
  .autocomplete-field {
    display: flex;
    flex-grow: 1;
    align-items: center;
    border: 1px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    background: var(--sds-color-background-default-primary);
    padding: var(--sds-size-space-300);
    gap: var(--sds-size-space-300);
    flex-wrap: wrap;
    min-height: 44px;
    transition: border-color 0.2s ease;
    cursor: text;
    position: relative;
  }

  .autocomplete-field.focused {
    border-color: var(--sds-color-border-positive-default);
    box-shadow: 0 0 0 var(--sds-size-stroke-focus-ring) var(--sds-color-background-positive-tertiary);
  }

  .autocomplete-field.has-error {
    border-color: var(--sds-color-border-danger-default);
  }

  .autocomplete-field.disabled {
    background: var(--sds-color-background-default-secondary);
    opacity: 0.6;
    cursor: not-allowed;
  }

  .autocomplete-field.open .dropdown-arrow {
    transform: rotate(180deg);
  }

  .selected-options {
    display: flex;
    gap: var(--sds-size-space-150);
    flex-wrap: wrap;
  }

  .option-chip {
    display: inline-flex;
    align-items: center;
    background: var(--sds-color-background-default-secondary);
    border: 1px solid var(--sds-color-border-default-secondary);
    border-radius: var(--sds-size-radius-200);
    padding: var(--sds-size-space-150) var(--sds-size-space-300);
    font-size: var(--sds-typography-body-size-small);
    font-family: var(--sds-typography-family-body);
    gap: var(--sds-size-space-150);
    color: var(--sds-color-text-default-default);
  }

  .option-chip button {
    border: none;
    background: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    color: var(--sds-color-text-default-tertiary);
    font-size: var(--sds-typography-scale-02);
    line-height: 1;
    border-radius: var(--sds-size-radius-full);
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
  }

  .option-chip button:hover:not(:disabled) {
    background: var(--sds-color-background-danger-tertiary);
    color: var(--sds-color-text-danger-default);
  }

  .option-chip button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .search-input {
    border: none;
    background: transparent;
    outline: none;
    flex: 1;
    min-width: 120px;
    font-size: var(--sds-typography-body-size-medium);
    font-family: var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .search-input:disabled {
    cursor: not-allowed;
    color: var(--sds-color-text-default-tertiary);
  }

  .search-input::placeholder {
    color: var(--sds-color-text-default-tertiary);
  }

  .dropdown-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--sds-color-text-default-tertiary);
    transition: transform 0.2s ease;
    pointer-events: none;
  }

  .loading-content {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    color: var(--sds-color-text-default-tertiary);
    font-size: var(--sds-typography-body-size-medium);
    font-family: var(--sds-typography-family-body);
  }

  /* Floating dropdown menu */
  .dropdown-menu {
    position: fixed;
    z-index: 1000;
    background: var(--sds-color-background-default-secondary);
    border: 1px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    box-shadow: 0 var(--sds-size-depth-100) var(--sds-size-depth-800) var(--sds-color-black-300);
    padding: var(--sds-size-space-300);
    max-height: 240px;
    overflow-y: auto;
  }

  .menu-item {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-300);
    padding: var(--sds-size-space-600) var(--sds-size-space-400);
    margin-bottom: var(--sds-size-space-150);
    border-radius: var(--sds-size-radius-200);
    cursor: pointer;
    font-size: var(--sds-typography-body-size-medium);
    font-family: var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
    transition: background-color 0.2s ease;
  }

  .menu-item:last-child {
    margin-bottom: 0;
  }

  .menu-item:hover,
  .menu-item.highlighted {
    background: var(--sds-color-background-default-tertiary-hover);
  }

  .start-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .option-label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .end-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .loading-message,
  .no-results,
  .no-options {
    padding: var(--sds-size-space-600) var(--sds-size-space-400);
    color: var(--sds-color-text-default-tertiary);
    font-size: var(--sds-typography-body-size-medium);
    font-family: var(--sds-typography-family-body);
    text-align: center;
  }

  .empty-search-message {
    padding: var(--sds-size-space-600) var(--sds-size-space-400);
    color: var(--sds-color-text-default-tertiary);
    font-size: var(--sds-typography-body-size-medium);
    font-family: var(--sds-typography-family-body);
    text-align: center;
    font-style: italic;
  }
`;
